import React from "react";
import appConfig from "../../../config/app.config";


const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentHomePage = () => {
    return (
        <div >
            <h2 className="text-xl font-bold">1.Home Page</h2>
            <div>
                <p>Enter the Open API URL on browser to land on the API portal homepage, as shown in the screenshot below</p>
                <p>Click on the <span className="font-bold">Sign In</span> button to proceed</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/home_page.png"} />
            </div>

            <div>
                <p>Post successful login, you would be redirected to the home page as shown in the screenshot below</p>
                <p>Click on the <span className="font-bold">Explore button</span> to proceed</p>
                <img className="pic" src={staticAssetsUrl + "user_manual/explore_home_page.png"} />
            </div>
        </div>
    )
}

export default ContentHomePage;